export default __webpack_public_path__ + "static/media/G_D_btn__Dashboard_Roll.fb1b222a.svg";